module.exports = __webpack_public_path__ + "img/ending.4b78a34e.gif";